import { useSearchParams } from "react-router-dom"
import { readLandingCountry } from "./landingCountry"

export function useLandingCountry() {
  const [searchParams] = useSearchParams()
  return readLandingCountry(searchParams)
}
